/**
 * EventListener defines a class which describes event listener.
 *
 * @typedef EventListener
 * @type {Object}
 * @property {type} String type of the EventListener
 * @property {callback} Function which is executed when an event is dispatched
 * @property {context} Context which is passed to the EventListener object
 */
var EventListener = /** @class */ (function () {
    function EventListener(type, callback, context) {
        this.type = type;
        this.callback = callback;
        this.context = context;
    }
    return EventListener;
}());
export { EventListener };
;
//# sourceMappingURL=EventListener.js.map